import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/OrderList/orderList.container"
    ).then((module) => ({
        default: module.OrderListContainer
    }))
);
